import { get, post, del } from "../../utils/axiosInstance";

const BASE_URL = "/rest/inventory";

export const fetchPriceLists = (page, vendor = null, dateFrom = null, dateTo = null) => {
  let url = `${BASE_URL}/offer_list/?page=${page}`;
  if (vendor) url += `&vendor=${vendor}`;
  if (dateFrom) url += `&from_date=${dateFrom}`;
  if (dateTo) url += `&to_date=${dateTo}`;
  return get(url);
};

export const fetchPricesListDetail = (id) => {
  let url = `${BASE_URL}/offer_list/${id}`;
  return get(url);
};

export const fetchPrices = (id, search, businessType, page) => {
  let url = `${BASE_URL}/offer_list/${id}/prices/?page=${page}`;
  if (search) url += `&search=${search}`;
  if (businessType) url += `&business_type=${businessType}`;
  return get(url);
};

export const fetchPricesListErrors = (id, search, page) => {
  let url = `${BASE_URL}/offer_list/${id}/errors/?page=${page}`;
  if (search) url += `&search=${search}`;
  return get(url);
};

export const pricesListSubmit = (data) => {
  const url = `${BASE_URL}/offer_list/`;
  let form_data = new FormData();
  let fileType = data.file.name.split(".").slice(-1)[0];
  form_data.append("offer_list", data.file, `offer_list_${new Date().toISOString().slice(0, 10)}.${fileType}`);
  form_data.append("vendor_id", data.vendorId);
  form_data.append("file_name", data.file.name);
  form_data.append("offer_date", data.date);
  if (data.description) form_data.append("description", data.description);
  return post(url, form_data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

export const offerItemsListSubmit = (data) => {
  const url = `${BASE_URL}/offer_item/`;
  let form_data = new FormData();
  let fileType = data.file.name.split(".").slice(-1)[0];
  form_data.append("offer_items_list", data.file, `offer_items_${new Date().toISOString().slice(0, 10)}.${fileType}`);
  form_data.append("vendor_id", data.vendorId);
  return post(url, form_data, {
    headers: {
      "content-type": "multipart/form-data",
    },
    responseType: "blob",
  });
};

export const reprocessPrice = (data) => {
  let url = `${BASE_URL}/offer_list/${data.offerListId}/reprocess_offer_error/`;
  let form_data = new FormData();
  form_data.append("error_id", data.errorId);
  form_data.append("item", data.itemId);
  form_data.append("conversion_factor", data.conversionFactor);
  form_data.append("default_unit", data.defaultUnit);
  form_data.append("is_per_lb", data.isPerLb);
  return post(url, form_data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

export const deletePricesList = (id) => {
  const url = `${BASE_URL}/offer_list/${id}/`;
  return del(url);
};

export const comparePriceLists = (ids, page, brand, businessType, search, comparisonType) => {
  let url = `${BASE_URL}/offer_item_price/compare/`;
  comparisonType === "paginated" ? (url += `?page=${page}&ids=${ids}`) : (url += `?ids=${ids}`);
  if (brand) url += `&brand=${brand}`;
  if (businessType) url += `&business_type=${businessType}`;
  if (search) url += `&search=${search}`;
  if (comparisonType) url += `&comparison_type=${comparisonType}`;
  return get(url);
};

export const fetchListCSV = (id, search, businessType) => {
  let url = `${BASE_URL}/offer_list/export_csv/?id=${id}`;
  if (search) url += `&search=${search}`;
  if (businessType) url += `&business_type=${businessType}`;
  return get(url, { responseType: "arraybuffer" });
};

export const getListPdf = (id, search, businessType) => {
  let url = `${BASE_URL}/offer_list/print_pdf/?id=${id}`;
  if (search) url += `&search=${search}`;
  if (businessType) url += `&business_type=${businessType}`;
  return get(url, { responseType: "arraybuffer" });
};

export const downloadPriceListsTemplate = () => {
  const url = `${BASE_URL}/price_list_template_file/download_template`;
  return get(url, { responseType: "blob" });
};

export const downloadOfferItemsTemplate = () => {
  const url = `${BASE_URL}/offer_items_template_file/download_template`;
  return get(url, { responseType: "blob" });
};
